import React from 'react'
import styled from 'styled-components'
import { BigTableData } from '../../data/bigTableData'
import TableInfiniteScroll from '../Incidents/TableInfiniteScroll'

const Wrapper = styled.div`
  padding-top: 20px;
  padding-left: 64px;
  width: 100%;
`

const Indicators: React.FC = () => {
  return (
    <Wrapper>
      <TableInfiniteScroll height100 data={BigTableData()} />
    </Wrapper>
  )
}

export default Indicators
